import { render, staticRenderFns } from "./TipsSelectedInfo.vue?vue&type=template&id=45fc7412&scoped=true&"
import script from "./TipsSelectedInfo.vue?vue&type=script&lang=js&"
export * from "./TipsSelectedInfo.vue?vue&type=script&lang=js&"
import style0 from "./TipsSelectedInfo.vue?vue&type=style&index=0&id=45fc7412&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45fc7412",
  null
  
)

export default component.exports